import React, { Component } from "react";
import GoogleMapReact from "google-map-react";
import marker from "../../img/map_marker.svg";
const GoogleMarker = () => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.google.com/maps/place/Restaurant+El+Greco/@52.329017,10.6668143,17z/data=!3m1!4b1!4m5!3m4!1s0x47af8ccac84714c5:0x60d0ada7f581a248!8m2!3d52.329017!4d10.669003"
      className="googlemap__info"
    >
      <img src={marker} alt="lol" className="googlemap__marker" />
      Restaurant El Greco
    </a>
  );
};

class SimpleMap extends Component {
  static defaultProps = {
    center: {
      lat: 52.329017,
      lng: 10.669003,
    },
    zoom: 11,
    yesIWantToUseGoogleMapApiInternals: true,
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: "630px", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyDwhNyk2KFfbidlrEa4FtLQw4tMFj1N7BM" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          yesIWantToUseGoogleMapApiInternals
        >
          <GoogleMarker
            lat={52.329017}
            lng={10.669003}
            text={"Restaurant El Greco"}
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default SimpleMap;
